import React, { useCallback, useEffect, useRef, useState } from 'react';
// eslint-disable-next-line import/no-named-default
import ReactPlayer from 'react-player/file';
import cx from 'classnames';
import styles from './../Player/Player.module.scss';
import PlayerBackground from '../PlayerBackground/PlayerBackground';
import { CustomButton } from '../Button/Button';
import { useTranslation } from 'react-i18next';

const defaultSetting = {
  pip: false,
  playbackRate: 1.0,
  loop: false,
};

// GIF duration in seconds
const GIF_DURATION = 3;

export default function ThumbnailPlayer({ url, animated, seekToValue, resetThumbnailPosition, emptyThumbnail }) {
  const { pip, playbackRate, loop } = defaultSetting;
  const { t } = useTranslation();

  const player = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [progress, setVideoProgress] = useState({});
  const [duration, setDuration] = useState(null);

  const setProgress = useCallback(newProgress => {
    setVideoProgress(prevState => ({ ...prevState, ...newProgress }));
  }, []);

  const onProgress = useCallback(
    state => {
      setProgress(state);
    },
    [setProgress]
  );

  const onDuration = value => {
    setDuration(value);
  };

  useEffect(() => {
    duration && player.current.seekTo(seekToValue, 'seconds');
  }, [seekToValue, duration]);

  useEffect(() => {
    setPlaying(animated);
  }, [animated]);

  useEffect(() => {
    if (progress.playedSeconds >= seekToValue + GIF_DURATION || progress.playedSeconds >= duration) {
      player.current.seekTo(seekToValue, 'seconds');
    }
  }, [progress]);

  return (
    <PlayerBackground className={cx(styles.videoPlayer)}>
      <div className={cx(styles.playerWrapper)}>
        <ReactPlayer
          playing={playing}
          ref={player}
          className={cx(styles.player)}
          width="100%"
          height="100%"
          url={url}
          loop={loop}
          pip={pip}
          playbackRate={playbackRate}
          onProgress={onProgress}
          progressInterval={50}
          volume={0}
          onDuration={onDuration}
        />
      </div>
      {emptyThumbnail ? (
        <div className={styles.emptyThumbnailOverlay}>
          <div className={styles.title}>{t('my_video.tools.thumbnail.empty_thumbnail')}</div>
          <CustomButton
            label={t('my_video.tools.thumbnail.empty_thumbnail_button')}
            onClick={resetThumbnailPosition}
            variant="secondary"
            className={styles.errorMessageButton}
          />
        </div>
      ) : null}
    </PlayerBackground>
  );
}
